import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Card, CardBody } from '../../../../components/card/card.jsx';
import { getPayrolls } from '../../../../store/HR/Payroll/PayrollSlice.js';
import { useTranslation } from 'react-i18next';
import Pagination from '../../../../components/Shared/Pagination/Pagination.jsx';
// import Loader from '../../../../components/Shared/Loader/Loader.js';
import ModalComponent from '../../../../components/Modal/ModalComponent.jsx';
import { AddPayroll } from './AddPayroll.jsx';
import { UpdatePayroll } from './UpdatePayroll.jsx';
import { usePermissions } from '../../../../Helper/Permisstions/usePermissions';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import Loading from '../../../../components/Shared/Loader/Loading';
import NtxTable from '../../../../components/DataTable/NtxTable';

const Payroll = () => {
  const { HasPermission } = usePermissions();

  const [Show, setShow] = useState(false);
  const [id, setId] = useState('');
  const { t, i18n } = useTranslation();
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage] = useState(10);

  const Navigate = useNavigate();
  const dispatch = useDispatch();
  /// Get all Payrolls from store
  const { Payrolls, loading, error } = useSelector(state => state.Payrolls);
  useEffect(() => {
    if (Payrolls?.length === 0) {
      dispatch(getPayrolls());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t('TypeOfDuration'), key: 'TypeOfDuration' },

    { title: t(''), key: 'action', className: 'text-end', sortable: false }
  ];

  const tableData = Payrolls?.map(item => {
    // let rowClass;

    return {
      Name: i18n.language === 'ar' ? item.name2 : item.name,
      TypeOfDuration: item.periodType === 'M' ? 'شهري' : 'أسبوعي',
      action: (
        <div className=' '>
          {/* <div className='btn-group'> */}
          <button
            type='button'
            onClick={() => Navigate(`${item.id}/ElementLink`)}
            className='btn btn-sm btn-outline-theme me-1'
          >
            <i className='fas fa-lg fa-fw me-2  fa-cog'></i>

            {t('PayrollSettings')}
          </button>

          {HasPermission('PayEditPayroll') && (
            <button
              type='button'
              className='btn btn-sm btn-outline-theme'
              data-bs-toggle='modal'
              data-bs-target='#modalUpdatePayroll'
              onClick={() => {
                setId(item.id);
                setShow(true);
              }}
            >
              <i className='far fa-lg fa-fw me-2 fa-edit'></i>
              {t('Button.Edit')}
            </button>
          )}
        </div>
      )
    };
  });

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome'
    },
    {
      name: t('Payrolls'),
      link: null
    }
  ];

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb BreadcrumbList={BcrumbList} PageName={t('Payrolls')} />
        {HasPermission('PayAddPayroll') && (
          <div className='ms-auto'>
            <Link
              to=''
              className='btn btn-theme me-1'
              data-bs-toggle='modal'
              data-bs-target='#modalAddPayroll'
              onClick={() => setShow(true)}
            >
              <i className='fa fa-plus-circle fa-fw me-1'></i>
              {t('AddPayroll')}
            </Link>
          </div>
        )}
      </div>
      <Card>
        <CardBody>
          <Loading loading={loading} error={error}>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </Loading>
        </CardBody>
      </Card>

      <ModalComponent id='modalAddPayroll' title={t('AddPayroll')}>
        {Show && <AddPayroll />}
      </ModalComponent>
      <ModalComponent id='modalUpdatePayroll' title={t('UpdatePayroll')}>
        {Show && id && <UpdatePayroll id={id} />}
      </ModalComponent>
    </>
  );
};

export default Payroll;
